import * as missionApi from "../../api/missionApi";
import StateIcon from "../StateIcon";

export default function ExportStatusMessage(props) {
    return (
        <span>
            <StateIcon
                state={missionApi.ExportingState(props.mission)}
                className={"me-4"}
            />
            Exporting
        </span>
    );
}
